import { useTranslation } from 'react-i18next';
import { BaseModal, BaseModalProps, Button, ModalActions } from '@anytag/shared-atoms';

export interface PublishModalProps extends BaseModalProps {
  loading?: boolean;
  onUpdateStatus?: (isDemoPublished?: boolean) => void;
}

export const PublishModal = ({ onClose, loading, onUpdateStatus, ...restProps }: PublishModalProps) => {
  const { t } = useTranslation();

  return (
    <BaseModal
      onClose={onClose}
      title={t('Publish')}
      description={
        <>
          <p>{t('ConfirmationForMakingCampaignPublic')}</p>
          <p className="text-red-70">{t('DemoPublishInfo')}</p>
        </>
      }
      {...restProps}
      asChild
    >
      <ModalActions>
        <Button variant="outline" className="min-w-26" title={t('Button.Cancel')} onClick={onClose} />
        <Button
          variant="solid"
          loading={loading}
          className="min-w-26"
          title={t('Button.Demo Publish')}
          onClick={() => onUpdateStatus?.(true)}
        />
        <Button
          variant="solid"
          loading={loading}
          className="min-w-26"
          title={t('Button.Publish')}
          onClick={() => onUpdateStatus?.(false)}
        />
      </ModalActions>
    </BaseModal>
  );
};
